import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  Platform,
  AlertController
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../providers/wh/summary-service";
import { WaybillOrderServiceProvider } from "../../../providers/qdb/qdb-service";
import { DatePipe } from "@angular/common";
import { HoldRtoModalComponent } from "../../qdb/search-parcel/hold-rto-modal/hold-rto-modal";

@Component({
  selector: "profile-information-page",
  templateUrl: "index.html",
  providers: [SummaryServiceProvider, WaybillOrderServiceProvider]
})
export class RTOHoldList {
  header_data: any;

  objectKeys = Object.keys;

  name: any;
  url: any;
  email: any;
  phoneNumber: any;
  rtoListData: any = [];

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public waybillOrderService: WaybillOrderServiceProvider,
    public datepipe: DatePipe,
    private alertCtrl: AlertController,
    public navParams: NavParams,
    public summaryService: SummaryServiceProvider,
    public loadingCtrl: LoadingController
  ) {
    this.header_data = {
      ismenu: true,
      ishome: false,
      title: "Hold RTO List",
      parentReloadData: d => {
        // this.load_cp_data(true)
      }
    };

    this.displayRTOHoldList();
  }

  displayRTOHoldList() {
    this.summaryService
      .getRtoHoldList(
        "/api/v0.2/backoffice/rtoholding?active=YES&expired=FALSE&size=1000"
      )
      .then((res: any) => {
        this.rtoListData = res.data.content;
        if (this.rtoListData.length) {
          this.rtoListData.map(ele => {
            if (ele.waybillOrderEntity.pickupFromClientTime.slice(-1) == "Z") {
              ele.waybillOrderEntity.pickupFromClientTime = ele.waybillOrderEntity.pickupFromClientTime.slice(
                0,
                -1
              );
            }
            if (ele.createTime.slice(-1) == "Z") {
              ele.createTime = ele.createTime.slice(0, -1);
            }
            if (ele.expiredTime.slice(-1) == "Z") {
              ele.expiredTime = ele.expiredTime.slice(0, -1);
            }
            return ele;
          });
        }
      });
  }

  updateRtoHold(item) {
    const modal = this.modalCtrl.create(HoldRtoModalComponent, {
      data: item,
      update: true
    });
    modal.onDidDismiss(data => {
      if (data) {
        this.displayRTOHoldList();
      }
    });
    modal.present();
  }

  removeRtoHold(item) {
    let message = "Are you sure you want to remove the hold time?";
    let alert = this.alertCtrl.create({
      title: "Confirm",
      message: `${message}`,
      buttons: [
        {
          text: "No",
          role: "cancel",
          handler: () => {
            console.log("Cancel clicked");
          }
        },
        {
          text: "Yes",
          handler: () => {
            this.summaryService.deleteRtoHolding(item.id).then((res: any) => {
              this.displayRTOHoldList();
            });
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/rto-hold-list/index.ts